import React, { useState } from 'react';
import {getDonneTelechargementDate, getDonneTelechargementOldDate} from './ConnectionBDD';

function convertirDate(dateStr) {
    const [annee, mois, jour] = dateStr.split('-');
    return `${jour}/${mois}/${annee}`;
}

const TelechargementDonneeOld = () => {
    const [startDate, setStartDate] = useState('');
    const [endDate, setEndDate] = useState('');
    const [organisation, setOrganisation] = useState('');
    const [email, setEmail] = useState('');

    const handleDownloadButtonClick = async (e) => {
        e.preventDefault();

        try {
            // Appeler la fonction pour récupérer les données CSV
            //console.log(convertirDate(startDate), convertirDate(endDate), organisation, email);

            const csvData = await getDonneTelechargementOldDate(convertirDate(startDate), convertirDate(endDate), organisation, email);


            // Tri des données CSV par date au format AAAA-MM-DD,donnée1,donnée2,...

            const lines = csvData.trim().split('\n'); // Découpe le CSV en lignes
            const header = lines.shift(); // Enlève l'en-tête (si présent)

            const lignesTriees = lines.sort((a, b) => {
                const dateA = new Date(a.split(',')[0]);
                const dateB = new Date(b.split(',')[0]);
                return dateA - dateB;
            });

            const sortedCsvData = [header, ...lignesTriees].join('\n');
            console.log(sortedCsvData);






            // Créer un lien de téléchargement
            const blob = new Blob([sortedCsvData], { type: 'text/csv' });
            const url = URL.createObjectURL(blob);
            const downloadLink = document.getElementById('downloadLink');
            downloadLink.href = url;
            downloadLink.download = 'weather_data_cefe '+startDate+' - '+endDate+ '.csv';

            // Afficher le lien de téléchargement et simuler le clic
            //downloadLink.style.display = 'block';
            downloadLink.click();

            // Nettoyer l'URL créée
            URL.revokeObjectURL(url);

        } catch (error) {
            console.error('Erreur lors de la récupération des données:', error);
        }


    };

    return (
        <div className="box">

            <h2>Téléchargement des données relevées manuellement</h2>
            <h2>(11 Janvier 1968 - 31 Decembre 2013)</h2>
            <form id="dataForm" onSubmit={handleDownloadButtonClick}>
                <label htmlFor="startDate">Date de début :</label>
                <input type="date" id="startDate" name="startDate" value={startDate}
                       min="1968-01-11"
                       max="2013-12-31"
                       onChange={(e) => setStartDate(e.target.value)} required/>

                <label htmlFor="endDate">Date de fin :</label>
                <input type="date" id="endDate" name="endDate" value={endDate}
                       min="1968-01-11"
                       max="2013-12-31"
                       onChange={(e) => setEndDate(e.target.value)} required/>

                <label htmlFor="organisation">Organisation :</label>
                <input type="text" id="organisation" name="organisation" value={organisation}
                       onChange={(e) => setOrganisation(e.target.value)} required/>

                <label htmlFor="email">Email :</label>
                <input type="email" id="email" name="email" value={email} onChange={(e) => setEmail(e.target.value)}
                       required/>



                <label><input type="checkbox" id="terms" name="terms" required/> J'ai lu et j'accepte les conditions d'utilisation ci-dessous</label>

                <button type="submit">Télécharger les données</button>

            </form>
            <a id="downloadLink" href="#" style={{display: 'none'}}>Cliquez ici pour télécharger les données</a>
        </div>
    );
};



export default TelechargementDonneeOld;
